import { render, staticRenderFns } from "./more-client-details-panel.vue?vue&type=template&id=6e93eba2"
import script from "./more-client-details-panel.vue?vue&type=script&lang=js"
export * from "./more-client-details-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports